import React from 'react';
import EntitlementApp from './components/EntitlementApp';

const EntitlementAppPage: React.FC = () => {
    return <EntitlementApp />;
};

export default EntitlementAppPage;
